import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import App from "./App";
import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    enableLogs: true,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

}

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={<p>Une erreur est survenue</p>}>
    <div id="pageContent" className="page-content header-clear-medium">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </div>
  </Sentry.ErrorBoundary>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();
reportWebVitals();